module.exports = __webpack_public_path__ + "img/orientation_Horizontal.e107bbba.svg";